import { render, staticRenderFns } from "./addRoomRepairList.vue?vue&type=template&id=84cdfde6&scoped=true"
import script from "./addRoomRepairList.vue?vue&type=script&lang=js"
export * from "./addRoomRepairList.vue?vue&type=script&lang=js"
import style0 from "./addRoomRepairList.vue?vue&type=style&index=0&id=84cdfde6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cdfde6",
  null
  
)

export default component.exports